"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LootBoxMintDialog = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const mui_inputs_core_1 = require("@dzambalaorg/mui-inputs-core");
const ui_kit_1 = require("@dzambalaorg/ui-kit");
const inputs_1 = require("../../../../../../inputs");
const box_content_1 = require("../../../box-content");
const LootBoxMintDialog = () => {
    return ((0, jsx_runtime_1.jsxs)(ui_kit_1.FormGrid, { columns: [2, 1], children: [(0, jsx_runtime_1.jsx)(inputs_1.LootBoxInput, {}), (0, jsx_runtime_1.jsx)(mui_inputs_core_1.TextInput, { name: "account" }), (0, jsx_runtime_1.jsx)(box_content_1.BoxContent, {})] }));
};
exports.LootBoxMintDialog = LootBoxMintDialog;
//# sourceMappingURL=index.js.map